import {Box, Divider, useTheme} from "@mui/material"
import React from "react"
import Content from "../../components/Content"

export const containerStyledTableGridPrototype = [
    "gridconfiguration",
    {
        key: "dividerAfterRow",
        type: "INTEGER",
        label: "Divider nach Zeile (y-Wert)",
        size: 6,
    },
    {
        key: "showVerticalBorders",
        type: "YESNO",
        label: "Vertikale Borders anzeigen",
        size: 6,
    },
]

const ARRAYOFFSET = 1

const ContainerStyledTableGrid = ({container}) => {
    const theme = useTheme()
    const headerBg = theme.STYLEDTABLE?.headerBackground ?? "#f8f9fa"
    const dividerColor = theme.STYLEDTABLE?.dividerColor ?? "#3958D5"
    const borderColor = theme.STYLEDTABLE?.borderColor ?? "#dee2e6"

    const {dividerAfterRow, showVerticalBorders, columncount} = container
    const dividerY = parseInt(dividerAfterRow) || 0

    const headerWidgets = container.children?.filter((entry) => entry.y <= dividerY)
    const contentWidgets = container.children?.filter((entry) => entry.y > dividerY)

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: `repeat(${columncount}, minmax(0, 1fr)))`,
                alignItems: "stretch",
            }}>
            {headerWidgets?.map((widget) => {
                const isLastColumn = widget.x + widget.w >= columncount
                return (
                    <Box
                        key={widget.id}
                        height="100%"
                        sx={{
                            gridColumn: widget.x + 1 + " /span " + widget.w,
                            gridRow: widget.y + 1 + " /span " + widget.h,
                            bgcolor: widget.y === 0 ? headerBg : "transparent",
                            padding: "8px 12px",
                            borderBottom: `1px solid ${borderColor}`,
                            borderRight: showVerticalBorders && !isLastColumn
                                ? `1px solid ${borderColor}`
                                : "none",
                        }}>
                        <Content child={widget} />
                    </Box>
                )
            })}
            <Box
                sx={{
                    gridColumn: `1 / span ${columncount}`,
                    gridRow: dividerY + 2,
                    display: "flex",
                    width: "100%",
                }}
            >
                <Divider
                    sx={{
                        width: "100%",
                        height: "2px",
                        bgcolor: dividerColor,
                    }}
                />
            </Box>
            {contentWidgets?.map((widget) => {
                const isLastColumn = widget.x + widget.w >= columncount
                return (
                    <Box
                        key={widget.id}
                        sx={{
                            gridColumn:
                                widget.x + ARRAYOFFSET + " /span " + widget.w,
                            gridRow:
                                widget.y + ARRAYOFFSET + 1 + " /span " + widget.h,
                            padding: "8px 12px",
                            borderBottom: `1px solid ${borderColor}`,
                            borderRight: showVerticalBorders && !isLastColumn
                                ? `1px solid ${borderColor}`
                                : "none",
                        }}>
                        <Content key={widget.i} child={widget} />
                    </Box>
                )
            })}
        </Box>
    )
}

export default ContainerStyledTableGrid
